export class EventCommentEntity {

    public static fromDto(dto: any): EventCommentEntity {
        const entity = new EventCommentEntity();
        entity.id = dto.id;
        entity.eventId = dto.eventId;
        entity.text = dto.text;
        entity.createdAt = dto.createdAt ?? null;
        return entity;
    }

    public static fromDtoArray(dtoArray: any[]): EventCommentEntity[] {
        if (!dtoArray) { return []; }
        return dtoArray.map(d => EventCommentEntity.fromDto(d));
    }

    public id: string = null;
    public eventId: string = null;
    public text: string = '';
    public createdAt: string = null;

    public toDto(): any {
        return { text: this.text };
    }
}
